import React from 'react';

import HpaContact from './HpaContact';
import EditHpaContact from './EditHpaContact';
import { USERINFO } from '../../../../data/reducer';
import { connect } from 'react-redux';

export const formType = {
  INFO: 'INFO',
  EDIT: 'EDIT',
  ADD: 'ADD',
};

const HpaContactFormContainer = (props) => {
  const {
    collapsibleContentState,
    hpaContactInfo,
    handleChange,
    errors,
    setErrors,
    lastEdited,
    confirmFieldValues,
    handleConfirmField,
    savedContactInfo,
  } = props;

  switch (collapsibleContentState) {
    case formType.INFO:
      return <HpaContact />;
    case formType.ADD:
    case formType.EDIT:
      return (
        <EditHpaContact
          errors={errors}
          setErrors={setErrors}
          hpaContactInfo={hpaContactInfo}
          handleChange={handleChange}
          confirmFieldValues={confirmFieldValues}
          handleConfirmField={handleConfirmField}
          lastEdited={lastEdited}
          savedContactInfo={savedContactInfo}
        />
      );
    default:
      return null;
  }
};

const mapStateToProps = (state) => {
  return {
    hpaContact: state[USERINFO],
  };
};

export default connect(mapStateToProps)(HpaContactFormContainer);
